import { Trans } from '@lingui/macro'

import * as React from 'react'

import { ButtonLarge } from '~ui/components/buttons/ButtonSizes/ButtonLarge'

type TProps = NoChildren & {
  onBackToMenu?: () => void
}

/**
 * Button with return to menu label used for redirecting user back to the app menu.
 */
export const BackToMenuButton: React.FC<TProps> = ({ onBackToMenu }) => {
  return (
    <ButtonLarge onClick={onBackToMenu} width={`100%`} bgColor={`secondary`}>
      <Trans>return to menu</Trans>
    </ButtonLarge>
  )
}
